export default () => {
  
  // Store Locator 
  window.addEventListener('infoWindowOpen', ev => {
    let infoWindow;
    const myInterval = setInterval(() => {
        infoWindow = ev.detail.content;
        if (infoWindow) {
          let infoDetails = infoWindow.querySelector('details');
          infoDetails.classList.add('open');
          clearInterval(myInterval);
          infoDetails.open = true;
        }
      }, 50);
    }); 
  
    window.addEventListener('DOMContentLoaded', () => {
      const poiList = document.querySelector('jump-poilist');
      if (poiList) {
        poiList.componentOnReady().then( element => {
          element.querySelectorAll('jump-poimap-place').forEach(item => {
            
            item.querySelector('details').addEventListener('click', ev => {
              poiList.querySelectorAll('details').forEach(detail => { 
                if (ev.srcElement.parentElement !== detail) { 
                  detail.open = false;
                }
              });
            });
          });
        })
      }
    });
  // Fine Store Locator

  //Searchbar store locator
  const poiList = document.querySelector('jump-poilist');
  const searchBar = document.querySelector('.Storelocator__InputSearch');

  if(searchBar) {
    searchBar.addEventListener('keyup', () => {
      let contentPoiList = poiList.querySelectorAll('.Storelocator__Content');
      contentPoiList.forEach(content => {
        let titlePoiList = content.getElementsByTagName('h3')[0];
        let filter = searchBar.value.toUpperCase();
        let txtValue = titlePoiList.textContent || titlePoiList.innerText;
        let details = content.parentNode;
        poiList.querySelectorAll('details').forEach(detail => {
          detail.open = false;
        });
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          poiList.classList.add('is-active');
          if(filter == ''){
            poiList.classList.remove('is-active');
          }
          details.style.display = '';
        } else { 
          if(filter == ''){
            poiList.classList.remove('is-active');
          }
          details.style.display = 'none';
      }
    })
  });
}
}
